import { ILoaderAsset } from '@renderforest/webwood-engine'

export const LOADER_BACKGROUND_IMAGE: ILoaderAsset = {
  key: 'loader-background',
  url: 'https://cdn.renderforest.com/webwood/loader/v1.0.3/loader-background.jpg'
}

export const LOADER_SHINE_IMAGE: ILoaderAsset = {
  key: 'loader-shine',
  url: 'https://cdn.renderforest.com/webwood/loader/v1.0.3/loader-shine.png'
}

export const LOADER_GRADIENT_IMAGE: ILoaderAsset = {
  key: 'loader-gradient',
  url: 'https://cdn.renderforest.com/webwood/loader/v1.0.3/loader-gradient-2.png'
}

export const LOADER_TEXT_BACKGROUND_IMAGE: ILoaderAsset = {
  key: 'loader-text-background',
  url: 'https://cdn.renderforest.com/webwood/loader/v1.0.3/loader-text-background.png'
}

export const LOADER_ASSETS: ILoaderAsset[] = [
  LOADER_BACKGROUND_IMAGE,
  LOADER_SHINE_IMAGE,
  LOADER_GRADIENT_IMAGE,
  LOADER_TEXT_BACKGROUND_IMAGE
]
